import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CheckBoxChecked from '@mui/icons-material/CheckBox';
import CheckBoxBlank from '@mui/icons-material/CheckBoxOutlineBlankOutlined';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';

//import SignaturePad from '../Components/SignaturePad';
import UnterschriftHaken from '../Components/UnterschriftHaken';
import personEntity from '../Entity/person';
//import signatureEntity from '../Entity/signature';
import validatorResult from '../Entity/validatorResult';
import Person from '../Components/Person';
import Fehlerbox from '../Components/Fehlerbox';
import MeldungWurdeVersandt from '../Components/MeldungWurdeVersandt';

import CustomDatePickerFieldNGX from "../Components/CustomDatePickerFieldNGX";
import CreatureEntity from '../Entity/Creature';
import CreatureConfigFields from '../Entity/CreatureConfigFields';
import Creatures from '../Components/Creatures';
import CustomSelectFieldNGX from "../Components/CustomSelectFieldNGX";

import {
  Standard as StandardDataField
} from "../Entity/Kennzeichnung/StandardDataFields";

import ValidatorPerson from '../Module/Validatoren/ValidatorPerson';

import {addEntityToState, addCreature} from '../Actions';

const style = {
  paper: {
    padding:"10px 20px 10px 20px",
    backgroundColor:"#fEfEfE",
  },
  paperAktiv: {
    padding:"10px 20px 10px 20px",
    backgroundColor:"#fcffc9",
  },
  checkboxItem: {
    paddingTop:"18px",
  },
}

const configCreatureExemplar = () => {
  let crtrConf = CreatureConfigFields()
  let crtr = CreatureEntity(crtrConf)
  return crtr;
}

const configHalter = (touched) => {
  let halter = personEntity(touched)
  halter.personTyp.display = true
  return halter;
}

const configHalterNeu = (touched) => {
  let halter = personEntity(touched)
  halter.personTyp.display = true
  halter.strasse.required = false
  halter.hausnummer.required = false
  halter.plz.required = false
  halter.ort.required = false
  return halter;
}

export default class FormularAbmeldung extends React.Component {

  constructor (props) {
    super(props);

    this.props.data.abmeldegrund = StandardDataField()
    this.props.data.leihgabe = false
    this.props.data.rueckgabedatum = StandardDataField()

        this.props.data['abgangsdatum'] = StandardDataField('')

    //this.props.data.unterschriftHalter = signatureEntity()
    this.props.data.halter = configHalter()
    this.props.data.halterNeu = configHalterNeu()
    //this.props.data.creatures = {}
    this.props.dispatch(
      addEntityToState('creatures', {})
    )
    this.props.dispatch(
      addCreature(configCreatureExemplar())
    )

    if (this.props.weitergabeAuswaehlen) {
      this.props.updateStandard('value')('abmeldegrund')()("Weitergabe")
    }

    this.props.data.ready = true
    
  }

  checkbox = (value) => {
    if (value === true) {
        return <CheckBoxChecked/>
    }
    return <CheckBoxBlank/>
  }

  touchAll = (obj, group) => {
    for (let item in obj) {
      if (obj[item].hasOwnProperty("touched")) {
        this.props.updateStandard('touched')(group)(item)(true)
      }
    }
  }

  validatorPersonResult = (person, checkPersoPass=false) => {

    if (!person.meta.touched) {
      return []
    }

    var res = ValidatorPerson(person, checkPersoPass)
    if ( res.valid === true ) {
      return [];
    }

    var display = [];
    res.message.map(
    (el) => display.push(<p key={el}>{el}</p>)
    )

    return display;

  }

  buttonPruefen = (label) => (
    <Button
      onClick={()=>{
        this.props.updateStandard('value')('meta')('touched')(true)
        if (this.props.data.hasOwnProperty("halter")) {
          this.touchAll(this.props.data.halter, 'halter')
          this.touchAll(this.props.data.halterNeu, 'halterNeu')
        }

        if (this.props.data.hasOwnProperty("abgangsdatum")) {
          this.props.updateStandard('touched')('abgangsdatum')()(true)
        }

        if (
          this.props.data.hasOwnProperty("creatures") 
          && Object.keys(this.props.data.creatures).length > 0
        ) {
          Object.keys(this.props.data.creatures).map(
            (element, key) => {
              this.touchAll(this.props.data.creatures[element], "creatures."+element)
            }
          )
        }

      }}
      variant="contained"
      color="primary"
      size="large"
      fullWidth={true}
    >
      &nbsp;<br/> {label}<br/>&nbsp;
    </Button>
  )

  absenden = () => {

    if (this.props.data.meta.touched.value !== true) {
      return this.buttonPruefen("Angaben Prüfen");
    }

    var msg = []

    if ( 
      this.props.data.hasOwnProperty("halter") &&
      !ValidatorPerson(this.props.data.halter).valid 
    ) {
      msg.push(
        <p key="ERR.Halter">
          Fehler bei Angaben zum Halter. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }

    if ( 
      this.props.data.hasOwnProperty("abmeldegrund") &&
      !this.props.data.abmeldegrund.value
    ) {
      msg.push(
        <p key="ERR.HOrt">
          Bitte geben Sie den Grund für die Abmeldung an.
        </p>
      )
    }

    if ( this.props.data.abgangsdatum.value === "" ) {
      msg.push(
        <p key="ERR.Erwerbsdatum">
          Fehlende Angabe zum Abgangsdatum.
        </p>
      )
    }

    if ( 
      this.props.data.abmeldegrund.value == "Weitergabe"
      && !ValidatorPerson(this.props.data.halterNeu).valid 
    ) {
      msg.push(
        <p key="ERR.HalterNeu">
          Fehler bei Angaben zum Halter. Bitte korrigieren Sie zunächst die markierten Felder.
        </p>
      )
    }


/*
    if ( 
      this.props.data.hasOwnProperty("unterschriftHalter") &&
      !this.props.data.unterschriftHalter.svg 
    ) {
      msg.push(
        <p key="ERR.SignaturHalter">
          Bitte unterschreiben Sie vor Abgabe
        </p>
      )
    }
*/

    let countCreatures = 0;
    for (let uniqueId in this.props.data.creatures) {
      countCreatures++
      if (
        this.props.data.creatures[uniqueId].hasOwnProperty("spezies")
        && (
          !this.props.data.creatures[uniqueId].spezies.hasOwnProperty("wiss")
          || this.props.data.creatures[uniqueId].spezies.wiss == ""
        )
      ) {
        msg.push(
          <p key={"ERR.Spec"+uniqueId}>
            Für das {countCreatures}. Tier wurde die Spezies nicht korrekt ausgewählt.
          </p>
        )
      }
    }

    if ( 
      this.props.data.meta.unterschrifthaken.value !== true
    ) {
      msg.push(
        <p key="ERR.UnterschriftHaken">
          Bitte bestätigen Sie, dass Ihre Angaben richtig und vollständig sind.
        </p>
      )
    }

    if (msg.length < 1) {
      return this.props.absenden(
        "Jetzt rechtsverbindlich einreichen/abschicken.",
        false,
        ()=>this.props.updateStandard('value')('meta')('wurdeVersandt')(true)
      )
    } else {
      return (
        <div>
          <Fehlerbox
            inhalt={msg}
          />
          <div style={{marginTop:"25px"}}></div>
          {this.props.absenden(
            "Jetzt rechtsverbindlich einreichen/abschicken.", 
            true,
            ()=>this.props.updateStandard('value')('meta')('wurdeVersandt')(true)
          )}
        </div>
      )
    }

  }

  render = () => {

    if (this.props.data.meta.wurdeVersandt.value) {
      return (
        <MeldungWurdeVersandt>
          Die Abmeldung wurde erfolgeich versandt.
        </MeldungWurdeVersandt>
      );
    }
    
    return (
      <div>
        {this.props.titel}

        <div style={{marginTop:"25px"}}></div>

        {this.props.pretext}

        <div style={{marginTop:"25px"}}></div>

        {this.props.data.hasOwnProperty('halter') &&
          <div>
              <Person
                id="PersonHalter"
                headline="Halter"
                withCard={true}
                data={this.props.data.halter}
                updaterValue={this.props.updateStandard('value')('halter')}
                updaterTouch={this.props.updateStandard('touched')('halter')}
                updaterValid={this.props.updateStandard('valid')('halter')}
                updaterMsg={this.props.updateStandard('msg')('halter')}
                restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
                konfiguration = {this.props.konfiguration.importierteKonfiguration.halter}
              />
            <Fehlerbox
              inhalt={this.validatorPersonResult(this.props.data.halter, true)}
            />
          </div>
        }

        <div style={{marginTop:"25px"}}></div>

        <Card>
            <CardContent>

              <CustomSelectFieldNGX
                id={"Abmeldegrund"}
                label="Abmeldegrund"
                value={this.props.data.abmeldegrund.value}
                updaterValue={this.props.updateStandard('value')('abmeldegrund')()}
                touched={this.props.data.abmeldegrund.touched}
                updaterTouch={this.props.updateStandard('touched')('abmeldegrund')()}
                updaterValid={this.props.updateStandard('valid')('abmeldegrund')()}
                list={[
                  {
                    id:'Tod',
                    label:'Tod des Individuums',
                  },
                  {
                    id:'Entlaufen',
                    label:'Entlaufen/Entflogen',
                  },
                  {
                    id:'Gestohlen',
                    label:'Gestohlen',
                  },
                  {
                    id:'Weitergabe',
                    label:'Abgabe an Dritte',
                  },
                ]}
              />

              <div style={{marginTop:"15px"}}></div>

              <CustomDatePickerFieldNGX
                id={"Abgangsdatum"}
                label="Datum des Abgangs"
                required={true}
                value={this.props.data.abgangsdatum.value}
                touched={this.props.data.abgangsdatum.touched}
                updaterValue={this.props.updateStandard('value')('abgangsdatum')()}
                updaterTouch={this.props.updateStandard('touched')('abgangsdatum')()}
                ariaLabel="Datum des Abgangs angeben"
                validator={()=>{
                  if( this.props.data.abgangsdatum.touched && !this.props.data.abgangsdatum.value ) {
                    this.props.updateStandard('valid')('abgangsdatum')(false)
                    return validatorResult(false, "Bitte treffen Sie eine Auswahl");
                  }
                  return validatorResult(true);
                }}
              />



              <Collapse in={this.props.data.abmeldegrund.value=="Weitergabe"}>
                <div style={{marginTop:"15px"}}>

                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">Handelt es sich um eine zeitlich begrenzte Leihgabe?</FormLabel>
                    <FormGroup aria-label="position" row>
                      <FormControlLabel
                        value="top"
                        control={
                          <Checkbox
                            onChange={
                              () => {
                                this.props.updateStandard(null)('leihgabe')()(true)
                                return;
                              }
                            }
                            checked={this.props.data.leihgabe === true}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                          />
                        }
                        label="Der Halterwechsel ist nur vorrübergehend (Leihgabe)"
                        labelPlacement="end"
                      />
                      <FormControlLabel
                        value="top"
                        control={
                          <Checkbox
                            onChange={
                              () => {
                                this.props.updateStandard(null)('leihgabe')()(false)
                                return;
                              }
                            }
                            checked={this.props.data.leihgabe === false}
                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
                          />
                        }
                        label="Der Halterwechsel ist auf Dauer angelegt"
                        labelPlacement="end"
                      />

                    </FormGroup>
                  </FormControl>

                  <Collapse in={this.props.data.leihgabe}>
                    <div style={{marginTop:"15px"}}>
                      <CustomDatePickerFieldNGX
                        id={"Rueckgabedatum"}
                        label="Voraussichtliches Datum der Rückgabe (sofern bekannt)"
                        required={false}
                        enableFuture={true}
                        value={this.props.data.rueckgabedatum.value}
                        touched={this.props.data.rueckgabedatum.touched}
                        updaterValue={this.props.updateStandard('value')('rueckgabedatum')()}
                        updaterTouch={this.props.updateStandard('touched')('rueckgabedatum')()}
                        ariaLabel="Voraussichtliches Datum der Rückgabe angeben"
                        validator={()=>{
                          return validatorResult(true);
                        }}
                      />                  

                      <p>
                        Bitte laden Sie bei Bedarf entsprechende Dokumente (Überlassungsvertrag) bei den 
                        jeweiligen Exemplaren unter "DOKUMENTE HINZUFÜGEN" hoch.
                      </p>
                    </div>
                  </Collapse>


                  <Person
                      id="PersonHalterNeu"
                      headline="Neuer Halter"
                      withCard={false}
                      data={this.props.data.halterNeu}
                      updaterValue={this.props.updateStandard('value')('halterNeu')}
                      updaterTouch={this.props.updateStandard('touched')('halterNeu')}
                      updaterValid={this.props.updateStandard('valid')('halterNeu')}
                      updaterMsg={this.props.updateStandard('msg')('halterNeu')}
                      restLadePlz={this.props.konfiguration.restPath + 'plz.php'}
                      konfiguration = {this.props.konfiguration.importierteKonfiguration.nachbesitzer}
                    />
                  <Fehlerbox
                    inhalt={this.validatorPersonResult(this.props.data.halterNeu, true)}
                  />
                </div>
              </Collapse>
            </CardContent>

        </Card>

        {this.props.data.hasOwnProperty("creatures") &&
          <div>
            {this.props.data.abmeldegrund.value=="Weitergabe"
              ? <h2 style={{textAlign:"center"}}>Welche Exemplare werden weitergegeben?</h2>
              : <h2 style={{textAlign:"center"}}>Welche Exemplare werden abgemeldet?</h2>
            }
            <Creatures
              form={this.props.form}
              data={this.props.data}
              creatures={this.props.data.creatures}
              dispatch={this.props.dispatch}
              updaterValue={this.props.updateStandard('value')}
              updaterTouch={this.props.updateStandard('touched')}
              updaterValid={this.props.updateStandard('valid')}
              konfiguration={this.props.konfiguration}
              creatureExemplar={configCreatureExemplar}
              restLadeSpezies={this.props.konfiguration.restPath + 'spezies.php'}
              restPath={this.props.konfiguration.restPath}
              kennzeichnungAnpassen={true}
              sonderfall={
                this.props.data.abmeldegrund.value == 'Tod' 
                ? 'abgabe-tod'
                : null
              }
            />
          </div>
        }

        <div style={{marginTop:"25px"}}></div>

        {this.props.hinweis}

        <div style={{marginTop:"25px"}}></div>

        <div style={{marginTop:"25px"}}></div>

        <UnterschriftHaken 
          value={this.props.data.meta.unterschrifthaken.value}
          update={
            this.props.updateStandard('value')('meta')('unterschrifthaken')
          }
        />

        {this.absenden()}

        {this.props.data.meta.wurdeVersandt.value&&
          this.props.followup
        }

      </div>
    )
  }

}